import { render, staticRenderFns } from "./ItemsGroup.vue?vue&type=template&id=4123599d&scoped=true&"
import script from "./ItemsGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsGroup.vue?vue&type=style&index=0&id=4123599d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123599d",
  null
  
)

export default component.exports